/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock= //1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车详情+get
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/traces
Mock.mock(/used_car\/ticket\/\d+\/traces/, 'get' + mockSwitch, {
  'code': 0,
  'message': '201',
  'data': {
    'ticket': {
      'id': 1, // #线索id
      'owner_name': '车主姓名',
      'owner_mobile': '车主手机号',
      'pedding': '待签合同',
      'created_at': '2017-12-12 12:12'
    },
    'traces|5': [{
      'id': 1, // #trace id
      'title': '展示操作名称/状态',
      'note': '备注',
      'operation_type': 110,
      'reference_id': 1, // #将用于跳转 / 获取详情的id
      'operator_name': '操作人/经手人姓名',
      'operator_role': '操作人/经手人角色', // #可能为空
      'price': 10000, // #估价价格
      'contract': { // #合同详情 已签合同才会有
        'id': 1, // #合同编号
        'price': 10000, // #合同价格
        'recepit_name': '收款人姓名',
        'bank_name': '开户行',
        'bank_card_number': '银行账号',
        'note': '个人股'
      },
      'finish_images': [],
      'created_at': '2017-12-12 12:12' // #创建时间
    }]
  }
})
// # 注意 operation_type 请参见 operation_type 列表
// # 如果 operation_type 为创建 则请展示ticket里面的owner信息
// # 如果 operation_type 为评估 则可以通过 reference_id 跳转到评估详情
// # 如果 operation_type 为签合同 则可以通过 contract->id 来获取合同图片
// # 如果 opeartion_type 为放款 则流程为终结

// 二手车向详情+get
// 接口地址  /api/v1/used_car/ticket
Mock.mock(/used_car\/ticket\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // # 线索 id
    'is_reported': true, // 查博士历史车况，是否查询过
    'vin': 'fwefewfewwefw', // # vin信息
    'status': 1,
    'status_code': 'created',
    'status_name': '已创建',
    'brand': '奥迪', // # 品牌名称
    'brand_logo': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 品牌logo
    'car_model_name': '雷克萨斯2015ES2000', // # 车型描述
    'jzg_car_model_id': 1, // 车型id - 缺
    'license_issued_on': '2012-12-12', // # 上牌日期（首次上牌日期）
    'mileage': 100000, // # 里程 公里
    'transfer_count': 1, // # 过户次数
    'jzg_color_id': 1, // # 颜色编号
    'jzg_color_name': '颜色名称',
    'owner_name': '车主姓名',
    'owner_mobile': '13811112222', // # 车主手机号
    'vehicle_province': '北京市', // 车辆归属地 -- 省份 -缺
    'vehicle_province_code': '110000', // 车辆归属地 -- 省份码 - 缺
    'vehicle_city': '北京市市辖区', // 车辆归属地 -- 城市  -缺
    'vehicle_city_code': '110100', // 车辆归属地 -- 城市码  -缺
    'channel': 1, // # 渠道
    'channel_name': '置换', // # 渠道名称
    'note': '备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注',
    'plate_number': '车牌号',
    'car_info_id': 1, // # 线索车辆评估信息快照id
    'reference_price': 1440000000, // # 市场参考价
    'appraised_price': 10440000000, // # 本店评估价
    'source': {
      'source_id': 1, // # 来源编号
      'source_name': '公众号',
      'sourcer_name': '提交人姓名', // # 当线索来源为销售/售后放行时才不为空
      'sourcer_role': '提交人角色', // # 当线索来源为销售/售后放行时才不为空
      'sourcer_mobile': '13811112222' // # 当线索来源为销售/售后放行时才不为空
    },
    'submitter': { // # 当线索由企业后或者管理后台创建才有 否则此字段为 null
      'role': '创建人角色',
      'name': '创建人名称',
      'mobile': '创建人手机号'
    }
  }
})

// 获取二手车线索支持的操作+get
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/operations
Mock.mock(/used_car\/ticket\/\d+\/operations$/, 'get' + mockSwitch, {
  'code': 0,
  'message': '201',
  'data': {
    'operations': {
      'is_support_contact': true, // # 是否支持跟进
      'is_support_close': true, // # 是否支持关闭
      'is_support_evaluate': true, // # 是否支持评估
      'is_support_enquiry': true, // # 是否支持询价
      'is_support_appraise': true, // # 是否支持估价
      'is_support_sign_contract': true, // # 是否支持签合同
      'is_support_finance_review': false, // # 是否支持财务审核通过
      'is_support_manager_review': false, // # 是否支持店总审核
      'is_support_finish': false // # 是否支持完成
    }
  }
})

// 获取二手车线索支持的操作+get
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/evaluation/car_info
Mock.mock(/used_car\/ticket\/\d+\/evaluation\/car_info$/, 'put' + mockSwitch, {
  'code': 0,
  'message': '201',
  'data': {
    'car_info_id': 1 // # 创建的预线索评估车辆信息id
  }
})
